module.exports = __webpack_public_path__ + "background.11302d3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/background.jpg
// module id = 345
// module chunks = 0